import { optionalStringQueryParam, useQueryStringParam } from "@octopusdeploy/portal-routes";
import type * as React from "react";
import { ControlledTabsContainer } from "./ControlledTabsContainer";
export type UrlNavigationTabsContainerProps<TValue extends string = string> = React.PropsWithChildren<{
    defaultValue: TValue;
    urlParameterName?: string;
}>;
/**
 * @param props
 * @param props.defaultValue The default value to use when not provided
 * @param props.urlParameterName The parameter name in the url, defaults to `activeTab`
 * @param props.children The children for this component. Only TabItem elements will be converted to tabs rendered by this component.
 * @deprecated
 * Deprecated: 08/12/2025
 * This component has been deprecated. Please use the `Tabs` and `Tab` components from the @octopusdeploy/design-system-components package instead. Please reach out to [#team-frontend-foundation-requests](https://octopusdeploy.slack.com/archives/C02PAUNL6J0)
 * if you are unsure how to replace this usage.
 */
export function UrlNavigationTabsContainer<TValue extends string>({ defaultValue, urlParameterName, children }: UrlNavigationTabsContainerProps<TValue>) {
    const urlParameterNameParameter = optionalStringQueryParam(urlParameterName ?? "activeTab");
    const [value, setValue] = useQueryStringParam(urlParameterNameParameter);
    return (<ControlledTabsContainer value={value ?? defaultValue} onChange={setValue}>
            {children}
        </ControlledTabsContainer>);
}
